export default __webpack_public_path__ + "static/faqTitlePattern-409d390573c6523b3276d38f1af9aa59.png";